import React, { useMemo } from 'react';
import { Modal, ModalVariant } from '@patternfly/react-core';
import ChartView from './ChartView';
import PropTypes from 'prop-types';
import { useTranslation } from 'localization/useTranslation';
import './ChartViewModal.css';
import { getColors } from 'utils/colors';
import _ from 'lodash';

const ChartViewModal = ({ isOpen, onClose, signal }) => {

  const initialSelection = useMemo(() => ([{ ...signal, signals: [{ ...signal?.signals[0], color: _.first(getColors({ usedColors: [] })) }] }]), [signal]);
  const T = useTranslation();

  return (
    <Modal
      className={'chart-view-modal'}
      tabIndex={0}
      title={T.sidebar.item.charts}
      variant={ModalVariant.large}
      isOpen={isOpen}
      onClose={onClose}>
      <ChartView initialSelection={initialSelection} showSelectSignals={false} />
    </Modal>
  );
};

ChartViewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  signal: PropTypes.object
};

export default ChartViewModal;
